import { render, staticRenderFns } from "./orderPoolInfo.vue?vue&type=template&id=01703db8&"
import script from "./orderPoolInfo.vue?vue&type=script&lang=js&"
export * from "./orderPoolInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports